import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const PermissionManagementRoutes = [
    {
        "url": `/manage-permissions/${hmapPathParamRegex}?:source`,
        "name": "appLayout.harriSH.access-portal.manage-permissions",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig,
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Manage Permissions"
            }
        ],
        "onEnter": ['$state', '$stateParams', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, navigationService, useGPSettingsNav) {
                navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams['hmapPath']).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.manage-permissions', {
                    hmapPath: $stateParams['hmapPath']
                }))
                    .then((isVisible) => {
                    if (!isVisible) {
                        Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                    }
                })
                    .catch(console.error);
            }
        ],
        "component": "permissionsGroupManagementContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission-management-v2", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/permission-management/permission-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/permissions/group/${hmapPathParamRegex}?group_id&&:brand_id&&:source`,
        "name": "appLayout.harriSH.group-permission",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Manage Permissions"
            }
        ],
        "component": "createEditGroupComponent",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission-management-v2", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/permission-management/permission-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/settings",
        "enableUTM": true,
        "name": "appLayout.harriSH.settings",
        "type": "frontend",
        "templateUrl": "../modules/settings/views/settings.html",
        "controller": 'SettingsController',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission-management-v2", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/permission-management/permission-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/permissions/user/${hmapPathParamRegex}?group_id&user_id&&:brand_id&&:source`,
        "name": "appLayout.harriSH.user-group-permission",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Manage Permissions"
            }
        ],
        "component": "createUserGroup",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission-management-v2", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/permission-management/permission-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/:view?tab",
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission-management-v2", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/hr-actions-templates/hr-actions-templates.downgrade.module");
                }
            }
        ]
    },
    {
        "url": `/user-management/${hmapPathParamRegex}`,
        "name": "appLayout.harriSH.access-portal.user-management",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | User Management"
            }
        ],
        "component": "permissionsUserManagementContainer",
        "onEnter": ['$state', '$stateParams', 'hUser', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, hUser, navigationService, useGPSettingsNav) {
                if (hUser.isTopLevelContext()) {
                    navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams['hmapPath']).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.user-management', {
                        hmapPath: $stateParams['hmapPath']
                    }))
                        .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                        }
                    })
                        .catch(console.error);
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission-management-v2", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/permission-management/permission-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/user-management/user/${hmapPathParamRegex}?user_id&&:brand_id&&source`,
        "name": "appLayout.harriSH.add-user-management",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig,
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | User Management"
            }
        ],
        "component": "addUserManagementContainer",
        "onEnter": ['$state', '$stateParams', 'hUser', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, hUser, navigationService, useGPSettingsNav) {
                if (hUser.isTopLevelContext()) {
                    navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams['hmapPath']).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.user-management', { hmapPath: $stateParams['hmapPath'] }))
                        .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                        }
                    })
                        .catch(console.error);
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission-management-v2", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/permission-management/permission-management.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/user-management/assign-user/${hmapPathParamRegex}?user_id&&:brand_id&&:source`,
        "name": "appLayout.harriSH.assign-user-group-management",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig,
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | User Management"
            }
        ],
        "component": "assignUserToGroupContainer",
        "onEnter": ['$state', '$stateParams', 'hUser', 'navigationService', 'useGPSettingsNav',
            function ($state, $stateParams, hUser, navigationService, useGPSettingsNav) {
                if (hUser.isTopLevelContext()) {
                    navigationService.isCurrentPathVisible(useGPSettingsNav($stateParams['hmapPath']).gpSettingsNav, $state.href('appLayout.harriSH.access-portal.user-management', { hmapPath: $stateParams['hmapPath'] }))
                        .then((isVisible) => {
                        if (!isVisible) {
                            Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                        }
                    })
                        .catch(console.error);
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["permission-management-v2", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/permission-management/permission-management.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=permission-management.routes.js.map